export enum ExamAccessType {
  CREATOR_AND_PUBLIC_ALL = 'CREATOR-AND-PUBLIC-ALL',
  TIME_FRAME = 'TIMEFRAME',
  SELECTED_EXAM = 'SELECTEDEXAM',
  PUBLIC_ALL = 'PUBLIC-ALL',
  ALL_X_TIMES = 'ALL-X-TIMES',
  ALL = 'ALL',
  FREE_ALL = 'FREE-ALL',
}